import axios from "axios";
import { Config } from "../../../core/config/config";
import { processLoadOptions } from "@/core/helper/datasource-query-helper";

const GATEWAY_URL = `${Config.VITE_APP_GATEWAY_URL}/api/account/admin/application-account`;

export const applicationAccountService = {
    createApplicationAccount: async function (params: any) {
        return axios.post(`${GATEWAY_URL}/create-application-account`, params)
            .then((response) => {
                return response.data;
            });
    },
    deleteApplicationAccount: async function (params: any) {
        return axios.delete(`${GATEWAY_URL}/delete-application-account`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
    getApplicationAccounts: async function (loadOptions: any) {
        const params = processLoadOptions(loadOptions);
        return axios.get(`${GATEWAY_URL}/get-application-accounts`, {
            params
        }).then((response) => {
            return response.data;
        });
    },
}